import React from "react";

const FGInwardToWarehouse = () => {
  return <div><h1>Work In Progress......</h1></div>;
};

export default FGInwardToWarehouse;
